/*!
 https://thaibault.github.com/jQuery-tools - v1.0
 Copyright Torben Sickert 16.12.2012
 Torben Sickert, http://creativecommons.org/licenses/by/3.0/deed.de
 */
(function () {
    var t, e = [].slice, n = [].indexOf || function (t) {
            for (var e = 0, n = this.length; n > e; e++)if (e in this && this[e] === t)return e;
            return -1
        };
    t = function (t) {
        var r, o;
        return r = function () {
            function r(e, n, r, o) {
                var i, a, s, l;
                for (this.$domNode = null != e ? e : null, this._options = null != n ? n : {}, this._defaultOptions = null != r ? r : {
                    logging: !1,
                    domNodeSelectorPrefix: "body",
                    domNode: {
                        hideJavaScriptEnabled: ".tools-hidden-on-javascript-enabled",
                        showJavaScriptEnabled: ".tools-visible-on-javascript-enabled"
                    }
                }, this._locks = null != o ? o : {}, l = this._consoleMethods, a = 0, s = l.length; s > a; a++)i = l[a], null == window.console && (window.console = {}), null == window.console[i] && (console[i] = t.noop());
                return this.self.prototype._javaScriptDependentContentHandled || (this.self.prototype._javaScriptDependentContentHandled = !0, t(this._defaultOptions.domNodeSelectorPrefix + " " + this._defaultOptions.domNode.hideJavaScriptEnabled).filter(function () {
                    return !t(this).data("javaScriptDependentContentHide")
                }).data("javaScriptDependentContentHide", !0).hide(), t(this._defaultOptions.domNodeSelectorPrefix + " " + this._defaultOptions.domNode.showJavaScriptEnabled).filter(function () {
                    return !t(this).data("javaScriptDependentContentShow")
                }).data("javaScriptDependentContentShow", !0).show()), this
            }

            return r.prototype.self = r, r.prototype.keyCode = {
                BACKSPACE: 8,
                COMMA: 188,
                DELETE: 46,
                DOWN: 40,
                END: 35,
                ENTER: 13,
                ESCAPE: 27,
                HOME: 36,
                LEFT: 37,
                NUMPAD_ADD: 107,
                NUMPAD_DECIMAL: 110,
                NUMPAD_DIVIDE: 111,
                NUMPAD_ENTER: 108,
                NUMPAD_MULTIPLY: 106,
                NUMPAD_SUBTRACT: 109,
                PAGE_DOWN: 34,
                PAGE_UP: 33,
                PERIOD: 190,
                RIGHT: 39,
                SPACE: 32,
                TAB: 9,
                UP: 38
            }, r.prototype.maximalSupportedInternetExplorerVersion = function () {
                var t, e, n;
                for (t = document.createElement("div"), e = n = 0; 9 > n && (t.innerHTML = "<!" + ("--[if gt IE " + e + "]><i></i><![e") + "ndif]-->", t.getElementsByTagName("i").length); e = ++n);
                if (!e) {
                    if (-1 !== window.navigator.appVersion.indexOf("MSIE 10"))return 10;
                    if (-1 !== window.navigator.userAgent.indexOf("Trident") && -1 !== window.navigator.userAgent.indexOf("rv:11"))return 11
                }
                return e
            }(), r.prototype._consoleMethods = ["assert", "clear", "count", "debug", "dir", "dirxml", "error", "exception", "group", "groupCollapsed", "groupEnd", "info", "log", "markTimeline", "profile", "profileEnd", "table", "time", "timeEnd", "timeStamp", "trace", "warn"], r.prototype._javaScriptDependentContentHandled = !1, r.prototype.__tools__ = !0, r.prototype.__name__ = "Tools", r.prototype.destructor = function () {
                return this.off("*"), this
            }, r.prototype.initialize = function (e) {
                return null == e && (e = {}), this._options = t.extend(!0, {}, this._defaultOptions, this._options, e), this._options.domNodeSelectorPrefix = this.stringFormat(this._options.domNodeSelectorPrefix, this.stringCamelCaseToDelimited(this.__name__)), this
            }, r.prototype.controller = function (e, n, o) {
                return null == o && (o = null), n = this.argumentsObjectToArray(n), null == e.__name__ && (e = new e(o), null == e.__tools__ && (e = t.extend(!0, new r, e))), null == o || o.data(e.__name__) || o.data(e.__name__, e), null != e[n[0]] ? e[n[0]].apply(e, n.slice(1)) : n.length && "object" !== t.type(n[0]) ? t.error('Method "' + n[0] + '" does not exist on $-extension ' + (e.__name__ + '".')) : e.initialize.apply(e, n)
            }, r.prototype.acquireLock = function (t, e, n) {
                var r;
                return null == n && (n = !1), r = function (t) {
                    return function (r) {
                        return e(r), n ? t.releaseLock(r) : void 0
                    }
                }(this), null != this._locks[t] ? this._locks[t].push(r) : (this._locks[t] = [], r(t)), this
            }, r.prototype.releaseLock = function (t) {
                return null != this._locks[t] && (this._locks[t].length ? this._locks[t].shift()(t) : delete this._locks[t]), this
            }, r.prototype.mouseOutEventHandlerFix = function (t) {
                var e;
                return e = this, function (n) {
                    var r;
                    for (r = n.toElement, n.relatedTarget && (r = n.relatedTarget); r && "BODY" !== r.tagName;) {
                        if (r === this)return;
                        r = r.parentNode
                    }
                    return t.apply(e, arguments)
                }
            }, r.prototype.log = function () {
                var n, r, o, i, a, s, l;
                return s = arguments[0], o = arguments[1], r = arguments[2], i = arguments[3], n = 5 <= arguments.length ? e.call(arguments, 4) : [], null == o && (o = !1), null == r && (r = !1), null == i && (i = "info"), (this._options.logging || o || "error" === i || "critical" === i) && (r ? a = s : "string" === t.type(s) ? (n.unshift(s), a = this.__name__ + " (" + i + "): " + this.stringFormat.apply(this, n)) : t.isNumeric(s) || "boolean" === t.type(s) ? a = this.__name__ + " (" + i + "): " + s.toString() : (this.log(",--------------------------------------------,"), this.log(s, o, !0), this.log("'--------------------------------------------'")), a && ((null == (null != (l = window.console) ? l[i] : void 0) || window.console[i] === t.noop()) && window.alert(a), window.console[i](a))), this
            }, r.prototype.info = function () {
                var t, n;
                return n = arguments[0], t = 2 <= arguments.length ? e.call(arguments, 1) : [], this.log.apply(this, [n, !1, !1, "info"].concat(t))
            }, r.prototype.debug = function () {
                var t, n;
                return n = arguments[0], t = 2 <= arguments.length ? e.call(arguments, 1) : [], this.log.apply(this, [n, !1, !1, "debug"].concat(t))
            }, r.prototype.error = function () {
                var t, n;
                return n = arguments[0], t = 2 <= arguments.length ? e.call(arguments, 1) : [], this.log.apply(this, [n, !0, !1, "error"].concat(t))
            }, r.prototype.critical = function () {
                var t, n;
                return n = arguments[0], t = 2 <= arguments.length ? e.call(arguments, 1) : [], this.log.apply(this, [n, !0, !1, "warn"].concat(t))
            }, r.prototype.warn = function () {
                var t, n;
                return n = arguments[0], t = 2 <= arguments.length ? e.call(arguments, 1) : [], this.log.apply(this, [n, !1, !1, "warn"].concat(t))
            }, r.prototype.show = function (e) {
                var n;
                return n = "", "string" === t.type(e) ? n = e : t.each(e, function (t, e) {
                    return void 0 === e ? e = "undefined" : null === e && (e = "null"), n += t.toString() + ": " + e.toString() + "\n"
                }), n || (n = n.toString()), t.trim(n) + '\n(Type: "' + t.type(e) + '")'
            }, r.prototype.generateDirectiveSelector = function (t) {
                var e;
                return e = this.stringCamelCaseToDelimited(t), e + ", ." + e + ", [" + e + "], " + ("[data-" + e + "], [x-" + e + "], ") + ("[" + e.replace("-", "\\:") + "]")
            }, r.prototype.removeDirective = function (t) {
                var e;
                return e = this.stringCamelCaseToDelimited(t), this.$domNode.removeClass(e).removeAttr(e).removeAttr("data-" + e).removeAttr("x-" + e).removeAttr(e.replace("-", ":"))
            }, r.prototype.getDirectiveValue = function (t) {
                var e, n, r, o, i, a;
                for (n = this.stringCamelCaseToDelimited(t), a = [n, "data-" + n, "x-" + n, n.replace("-", "\\:")], o = 0, i = a.length; i > o; o++)if (e = a[o], r = this.$domNode.attr(e), null != r)return r
            }, r.prototype.sliceDomNodeSelectorPrefix = function (e) {
                var n;
                return null != (null != (n = this._options) ? n.domNodeSelectorPrefix : void 0) && this.stringStartsWith(e, this._options.domNodeSelectorPrefix) ? t.trim(e.substring(this._options.domNodeSelectorPrefix.length)) : e
            }, r.prototype.getDomNodeName = function (t) {
                return t.match(new RegExp("^<?([a-zA-Z]+).*>?.*"))[1]
            }, r.prototype.grabDomNode = function (e, n) {
                var r;
                return r = {}, null != e && (null != n ? (n = t(n), t.each(e, function (t, e) {
                    return r[t] = n.find(e)
                })) : t.each(e, function (n) {
                    return function (o, i) {
                        var a;
                        return a = i.match(", *"), a && t.each(i.split(a[0]), function (t, r) {
                            return t ? i += ", " + n._grabDomNodeHelper(t, r, e) : i = r
                        }), r[o] = t(n._grabDomNodeHelper(o, i, e))
                    }
                }(this))), this._options.domNodeSelectorPrefix && (r.parent = t(this._options.domNodeSelectorPrefix)), r.window = t(window), r.document = t(document), r
            }, r.prototype.getURLVariable = function (e) {
                var r;
                return r = [], t.each(window.location.search.substring(1).split("&"), function (t, e) {
                    var n;
                    return n = e.split("="), t = window.decodeURIComponent(n[0]), e = window.decodeURIComponent(n[1]), r.push(t), r[t] = e
                }), "string" === t.type(e) ? n.call(r, e) >= 0 ? r[e] : void 0 : r
            }, r.prototype.determineUniqueScopeName = function (t, e) {
                var n;
                for (null == t && (t = "callback"), null == e && (e = window); ;)if (n = t + window.parseInt(window.Math.random() * window.Math.pow(10, 10)), null == e[n])break;
                return n
            }, r.prototype.getMethod = function () {
                var n, r, o, i;
                return r = arguments[0], i = arguments[1], n = 3 <= arguments.length ? e.call(arguments, 2) : [], null == i && (i = this), o = this.argumentsObjectToArray(arguments), "string" === t.type(r) && "object" === t.type(i) ? function () {
                    var e;
                    return i[r] || t.error('Method "' + r + "\" doesn't exists in " + ('"' + i + '".')), e = arguments.callee, o = t.Tools().argumentsObjectToArray(arguments), o.push(e), i[r].apply(i, o.concat(n))
                } : (o.unshift(i), o.unshift(r), t.proxy.apply(t, o))
            }, r.prototype.debounce = function () {
                var t, n, r, o, i, a;
                return n = arguments[0], i = arguments[1], t = 3 <= arguments.length ? e.call(arguments, 2) : [], null == i && (i = 600), r = !1, a = null, o = this, function () {
                    var e, s;
                    return e = o.argumentsObjectToArray(arguments), r ? a = e.concat(t || []) : (r = !0, s = window.setTimeout(function (t) {
                        return function () {
                            return r = !1, a ? (n.apply(t, a), a = null) : void 0
                        }
                    }(this), i), n.apply(this, e.concat(t || [])))
                }
            }, r.prototype.fireEvent = function () {
                var t, n, r, o, i;
                return o = arguments[0], n = arguments[1], i = arguments[2], t = 4 <= arguments.length ? e.call(arguments, 3) : [], null == n && (n = !1), null == i && (i = this), i || (i = this), r = "on" + this.stringCapitalize(o), n || (i[r] ? i[r].apply(i, t) : i["_" + r] && i["_" + r].apply(i, t)), i._options && i._options[r] ? (i._options[r].apply(i, t), !0) : !1
            }, r.prototype.on = function () {
                return this._bindHelper(arguments, !1)
            }, r.prototype.off = function () {
                return this._bindHelper(arguments, !0, "off")
            }, r.prototype.argumentsObjectToArray = function (t) {
                return Array.prototype.slice.call(t)
            }, r.prototype.round = function (t, e) {
                return null == e && (e = 0), Math.round(t * Math.pow(10, e)) / Math.pow(10, e)
            }, r.prototype.stringStartsWith = function (t, e) {
                return 0 === t.indexOf(e)
            }, r.prototype.stringEndsWith = function (t, e) {
                return t.length >= e.length && t.lastIndexOf(e) === t.length - e.length
            }, r.prototype.stringFormat = function () {
                var n, r;
                return r = arguments[0], n = 2 <= arguments.length ? e.call(arguments, 1) : [], n.unshift(r), t.each(n, function (t, e) {
                    return r = r.replace(new RegExp("\\{" + t + "\\}", "gm"), e)
                }), r
            }, r.prototype.stringCamelCaseToDelimited = function (t, e) {
                return null == e && (e = "-"), t.replace(new window.RegExp("(.)([A-Z])", "g"), function () {
                    return arguments[1] + e + arguments[2]
                }).toLowerCase()
            }, r.prototype.stringDelimitedToCamelCase = function (t, e) {
                return null == e && (e = "-"), t = t.replace(new window.RegExp("[^a-zA-Z0-9]([a-z])", "g"), function (t, e) {
                    return e.toUpperCase()
                }).replace(window.RegExp("[^a-zA-Z0-9]", "g"), ""), this.stringLowerCase(t)
            }, r.prototype.stringLowerCase = function (t) {
                return t.charAt(0).toLowerCase() + t.substring(1)
            }, r.prototype.stringCapitalize = function (t) {
                return t.charAt(0).toUpperCase() + t.substring(1)
            }, r.prototype.stringAddSeparatorToPath = function (e, n) {
                return null == n && (n = "/"), e = t.trim(e), e.substr(-1) !== n && e.length ? e + n : e
            }, r.prototype.sendToIFrame = function (e, n, r, o, i) {
                var a, s, l;
                null == o && (o = "post"), null == i && (i = !1), a = t("<form>").attr({
                    action: n,
                    method: o,
                    target: "string" === t.type(e) ? e : e.attr("name")
                });
                for (s in r)l = r[s], a.append(t("<input>").attr({type: "hidden", name: s, value: l}));
                return a.submit().remove(), "function" == typeof e.on ? e.on("load", function () {
                    return i ? e.remove() : void 0
                }) : void 0
            }, r.prototype.sendToExternalURL = function (e, n, r, o) {
                var i;
                return null == r && (r = "post"), null == o && (o = !0), i = t("<iframe>").attr({name: this.__name__.charAt(0).toLowerCase() + this.__name__.substring(1) + (new Date).getTime()}).hide(), this.$domNode.after(i), this.sendToIFrame(i, e, n, r, o)
            }, r.prototype._bindHelper = function (e, n, r) {
                var o;
                return null == n && (n = !1), null == r && (r = "on"), o = t(e[0]), "object" !== t.type(e[1]) || n ? (e = this.argumentsObjectToArray(e).slice(1), 0 === e.length && e.push(""), -1 === e[0].indexOf(".") && (e[0] += "." + this.__name__), n ? o[r].apply(o, e) : o[r].apply(o, e)) : (t.each(e[1], function (t) {
                    return function (e, n) {
                        return t[r](o, e, n)
                    }
                }(this)), o)
            }, r.prototype._grabDomNodeHelper = function (e, n, r) {
                var o;
                return o = "", this._options.domNodeSelectorPrefix && (o = this._options.domNodeSelectorPrefix + " "), this.stringStartsWith(n, o) || this.stringStartsWith(t.trim(n), "<") ? t.trim(n) : (r[e] = o + n, t.trim(r[e]))
            }, r
        }(), t.fn.Tools = function () {
            return (new r).controller(r, arguments, this)
        }, t.Tools = function () {
            return (new r).controller(r, arguments)
        }, t.Tools["class"] = r, o = t.fn.prop, t.fn.prop = function (t, e) {
            var n;
            if (arguments.length < 3 && ("#text" === (n = this[0].nodeName) || "#comment" === n) && null != this[0][t]) {
                if (1 === arguments.length)return this[0][t];
                if (2 === arguments.length)return this[0][t] = e, this
            }
            return o.apply(this, arguments)
        }
    }, null != this.require ? (this.require.scopeIndicator = "jQuery.Tools", this.require([["jQuery", "jquery-2.1.1"]], t)) : t(this.jQuery)
}).call(this);